<template>
  <div class="common">
    <div class="card-main" style="padding:15px 30px;">
      <div class="page-title"><a-divider class="title-divider" type="vertical" />额度与账户</div>
      <div class="spaceAround">
        <div class="spaceCenter card-item">
          <div id="quotaChart" style="width:100px;height:100px;margin-right:30px;"></div>
          <div>
            <div class="content-title text-color-black">{{userObj.cstNm | defaultText(4)}}</div>
            <div class="content-line">
              专属账户
              <span class="content-span text-color-black">
                <user-account :account="userObj.accNo|defaultText(19)"></user-account>
              </span>
              <span class="pointer link-text" @click="tofunding" v-if="$store.getters['home/getPATHMAP']['account/funding']">回单打印</span>
            </div>
            <div class="content-line ">
              开户银行
              <span class="content-span text-color-black">{{userObj.accBlngBnk | defaultText(4)}}</span>
            </div>
            <div class="content-line">
              大额行号
              <span class="content-span text-color-black">
                <user-account :account="userObj.largeAmountAccount|defaultText(12)"></user-account>
              </span>
            </div>
          </div>
        </div>
        <a-divider type="vertical" style="height:70px;background:#eceeef;" />
        <div class="spaceAround card-item">
          <div>
            <div class="main-item-img spaceCenter">
              <img src="../assets/images/zhanghu.png"/>
            </div>
            <div class="main-item-text">账户</div>
          </div>
          <div>
            <user-currency :value="userObj.accBal" class="text-size-24 text-color-black" style="font-weight:bold;"></user-currency>
            <div style="margin-bottom:10px;">可用余额(元)</div>
            <user-currency :value="userObj.accFrzAmt" class="text-size-20 text-color-black" style="font-weight:bold;"></user-currency>
            <div>冻结金额(元)</div>
          </div>
          <div>
            <div style="margin-bottom:15px;">
              <a-button @click="recharge" type="primary" class="main-btn-big">充值</a-button>
            </div>
            <div>
              <a-button @click="withdrawal" class="main-btn-big btn-blue-line">提现</a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-main" style="padding:15px 30px;">
      <div class="page-title"><a-divider class="title-divider" type="vertical" />资产与负债</div>
      <div class="spaceAround">
        <div class="spaceAround card-item">
          <div>
            <div class="main-item-img spaceCenter" style="background:#D7ECFF;">
              <img src="../assets/images/zichan.png"/>
            </div>
            <div class="main-item-text">
              <span class="text-size-16">{{assets.gldCount}}</span>笔
            </div>
          </div>
          <div>
            <user-currency :value="assets.gldGldBalTAmt" class="text-size-20 text-color-black" style="font-weight:bold;"></user-currency>
            <div class="text-color-grey">应收祺信(元)</div>
          </div>
          <div>
            <div style="margin-bottom:15px;">
              <a-button @click="togoldpay" type="primary" class="main-btn-big" :disabled="!$store.getters['home/getPATHMAP']['circulation/goldpay']">支付</a-button>
            </div>
            <div>
              <a-button @click="toborrow" class="btn-blue-line main-btn-big" :disabled="!$store.getters['home/getPATHMAP']['circulation/borrow']">融资</a-button>
            </div>
          </div>
        </div>
        <a-divider type="vertical" style="height:70px;background:#eceeef;" />
       <div class="spaceAround card-item">
          <div>
            <div class="main-item-img spaceCenter" style="background:#FFDFD7;">
              <img src="../assets/images/fuzhai.png"/>
            </div>
            <div class="main-item-text">
              <span class="text-size-16">{{liabilities.gldCount}}</span>笔
            </div>
          </div>
          <div>
            <user-currency :value="liabilities.topGldBalTAmt" class="text-size-20 text-color-black" style="font-weight:bold;"></user-currency>
            <div class="text-color-grey">应付祺信(元)</div>
          </div>
          <div>
            <div style="margin-bottom:15px;">
              <a-button @click="toissue" type="primary" class="main-btn-big" :disabled="!$store.getters['home/getPATHMAP']['bill-issue/issue']">开立</a-button>
            </div>
            <div>
              <a-button @click="topayment" class="btn-blue-line main-btn-big" className="button-color-sunset" :disabled="!$store.getters['home/getPATHMAP']['bill-payment/payment']">兑付</a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-main text-color-grey" style="padding:15px 30px;">
      <div class="page-title"><a-divider class="title-divider" type="vertical" />待办与到期</div>
      <div class="spaceLeft">
        <div class="text-item">
          <span>待签署法律文本</span>
          <div><span class="text-color-gold text-size-18 pointer"  @click="tolegaltexts">{{toDo.contractCount||0}}</span> 笔</div>
        </div>
        <div class="text-item">
          <span>待处理的邀请信息</span>
          <div><span class="text-color-gold text-size-18">{{toDo.inviteCount||0}}</span> 笔</div>
        </div>
        <div class="text-item">
          <span>待查看付款通知书</span>
          <div><span class="text-color-gold text-size-18">{{toDo.paymentCount||0}}</span> 笔</div>
        </div>
        <div class="text-item">
          <span>待付费用</span>
          <div><span class="text-color-gold text-size-18 pointer" @click="topayfee">{{toDo.manageFeeCount||0}}</span> 笔</div>
        </div>
      </div>
      <div class="text-item">
        <span>待付罚息</span>
        <div><user-currency :value="toDo.goldUpdIntTAmt" class="text-size-18 text-color-gold"></user-currency>元</div>
      </div>
      <a-divider dashed style="background:#ddd;margin:-5px 0 15px 0;" />
      <div class="spaceLeft">
        <div class="text-item">
          <span>今日到期</span>
          <div>
            <span class="text-color-gold text-size-18">{{dueToToDay.gldCount||0}}</span>
            <span class="text-margin">笔</span>
            <user-currency :value="dueToToDay.gldGldToPayTAmt" class="text-size-18 text-color-black"></user-currency>元
          </div>
        </div>
        <div class="text-item">
          <span>未来一周到期</span>
          <div>
            <span class="text-color-gold text-size-18">{{dueToNexWeek.gldCount||0}}</span>
            <span class="text-margin">笔</span>
            <user-currency :value="dueToNexWeek.gldGldToPayTAmt" class="text-size-18 text-color-black"></user-currency>元
          </div>
        </div>
        <div class="text-item">
          <span>未来一月到期</span>
          <div>
            <span class="text-color-gold text-size-18">{{dueToNextMonth.gldCount||0}}</span>
            <span class="text-margin">笔</span>
            <user-currency :value="dueToNextMonth.gldGldToPayTAmt" class="text-size-18 text-color-black"></user-currency>元
          </div>
        </div>
        <div class="text-item">
          <span>已逾期</span>
          <div>
            <span class="text-color-gold text-size-18">{{dueTo.gldCount||0}}</span>
            <span class="text-margin">笔</span>
            <user-currency :value="dueTo.allMoney" class="text-size-18 text-color-black"></user-currency>元
          </div>
        </div>
      </div>
      <div id="todoDueChart" style="width:100%;height:354px;margin-top:20px;"></div>
    </div>

    <!-- 充值弹窗 -->
    <a-modal
      width="500px"
      title="充值"
      :visible="modalShow"
      :footer="null"
      @cancel="() => modalShow=false"
    >
      <div>
        <p class="text-color-gold">请通过网银或银行柜台转账到下列账户，完成充值</p>
        <div class="content-line">
          用户名称：
          <span class="text-color-black">{{userObj.cstNm | defaultText(4)}}</span>
        </div>
        <div class="content-line">
          收款账号：
          <span class="text-size-12">
            <user-account :account="userObj.accNo|defaultText(19)"></user-account>
          </span>
        </div>
        <div class="content-line">
          开户银行：
          <span class="text-color-black">{{userObj.accBlngBnk | defaultText(4)}}</span>
        </div>
        <div class="content-line">账户余额可在<span @click="modalShow=false" class="text-color-blue pointer main-link">账户总览</span>中查看</div>
        <div class="content-line" v-if="$store.getters['home/getPATHMAP']['account/funding']">
          <span @click="toAccountFunding('receiptCol')" class="text-color-blue pointer main-link">回单打印</span>
          <span @click="toAccountFunding('detailsCol')" class="text-color-blue pointer main-link">资金明细</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import userCurrency from "@/components/user-currency/user-currency";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { goldTicketApi, backlogApi, expirApi, getLinesApi } from "@/api/center.js";
export default {
  name: "mainPage",
  components: {
    userCurrency,
  },
  data() {
    const PRIMARY_COLOR = '#1E88F5';
    const ACCENT_COLOR = '#FFCC01';
    const LEGEND_TEXT_COLOR = '#667380';
    const AXIS_LINE_COLOR = '#DFE2E6';
    const AXIS_GRID_COLOR = '#EDF1F5';
    const AXIS_LABEL_COLOR = '#9EA8B2';
    return {
      liabilities: {},
      assets: {},
      toDo: {},
      dueToToDay: {}, // 今日到期
      dueToNexWeek: {}, // 未来一周到期
      dueToNextMonth: {},
      dueTo: {},
      todoDueChartOption: {
        title: {
          text: "",
        },
        tooltip: {
          trigger: "item",
          position: "top",
          padding: [5, 15],
          formatter: ({ data }) => {
            // tslint:disable-next-line:no-unused-variable
            const [date, amount, count] = data;
            return `${this.utils.splitK(amount)}元 ${count}笔`;
          },
          extraCssText: "border-radius: 41px;",
        },
        legend: {
          data: [
            {
              name: "祺信融资",
              icon: "circle",
            },
            {
              name: "应付祺信",
              icon: "circle",
            },
          ],
          right: 85,
          itemGap: 30,
          itemHeight: 11,
          textStyle: {
            color: LEGEND_TEXT_COLOR,
            fontSize: "14",
            lineHeight: "20",
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          splitLine: {
            show: true,
            interval: 0, // force all splitlines to show for category type
            lineStyle: {
              color: AXIS_GRID_COLOR,
              opacity: 0.6,
            },
          },
          axisLine: {
            lineStyle: {
              color: AXIS_LINE_COLOR,
            },
          },
          axisTick: {
            length: 0,
          },
          axisLabel: {
            color: AXIS_LABEL_COLOR,
            interval: 0, // force all axisLabels to show for category type
            formatter(value, index) {
              const [year, month] = value.split("-");
              const isFirstPoint = index === 0;
              const isFirstMonth = +month === 1;
              const showYear = isFirstPoint || isFirstMonth;
              return `${showYear ? year + "年" : ""}${+month}月`;
            },
          },
        },
        yAxis: [
          {
            name: "融资金额(元)",
            min: 0,
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: AXIS_GRID_COLOR,
                opacity: 0.6,
              },
            },
            axisLine: {
              lineStyle: {
                color: AXIS_LINE_COLOR,
              },
            },
            axisTick: {
              length: 0,
            },
            axisLabel: {
              formatter: "{value}",
              color: AXIS_LABEL_COLOR,
              margin: 40,
            },
            nameTextStyle: {
              color: PRIMARY_COLOR,
              fontWeight: "normal",
              fontFamily: "PingFangSC-Regular",
            },
          },
          {
            name: "应付金额(元)",
            min: 0,
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: AXIS_GRID_COLOR,
                opacity: 0.6,
              },
            },
            axisLine: {
              lineStyle: {
                color: AXIS_LINE_COLOR,
              },
            },
            axisTick: {
              length: 0,
            },
            axisLabel: {
              formatter: "{value}",
              color: AXIS_LABEL_COLOR,
              margin: 40,
            },
            nameTextStyle: {
              color: ACCENT_COLOR,
              fontWeight: "normal",
              fontFamily: "PingFangSC-Regular",
            },
          },
        ],
        series: [
          {
            name: "祺信融资",
            type: "line",
            data: [],
            showAllSymbol: true,
            symbolSize: 8,
            itemStyle: {
              color: PRIMARY_COLOR,
              borderWidth: 2,
            },
            areaStyle: {
              color: PRIMARY_COLOR,
              opacity: 0.1,
            },
            tooltip: {
              backgroundColor: PRIMARY_COLOR,
            },
          },
          {
            name: "应付祺信",
            type: "line",
            data: [],
            showAllSymbol: true,
            symbolSize: 8,
            yAxisIndex: 1,
            itemStyle: {
              color: ACCENT_COLOR,
              borderWidth: 2,
            },
            areaStyle: {
              color: ACCENT_COLOR,
              opacity: 0.1,
            },
            tooltip: {
              backgroundColor: ACCENT_COLOR,
            },
          },
        ],
      },
      modalShow:false
    };
  },
  created() {
    this.goldTicket();
    this.getBacklog();
    this.getExpirToDay();
    this.getExpirNexWeek();
    this.getExpirNextMonth();
    this.getLines();
  },
  mounted() {
    this.quotaChartDorw();

    window.onresize = () => {
        return (() => {
            this.todoDueChart&&this.todoDueChart.resize();
        })();
    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj",
    }),
  },
  methods: {
    goldTicket() {
      goldTicketApi().then((res) => {
        this.liabilities = res.data.goldTicketPayable||{};
        this.assets = res.data.goldTicketReceivable||{};
      })
      .catch((err) => {console.log(err);});;
    },
    getBacklog() {
      backlogApi().then((res) => {
        this.toDo = res.data||{};
      }).catch((err) => {console.log(err);});;
    },
    getExpirToDay() {
      const params = {
        exBgdt: this.utils.dateFormat(new Date(), "yyyy-MM-dd"),
        exExdt: this.utils.dateFormat(new Date(), "yyyy-MM-dd"),
      };
      expirApi(params).then((res) => {
        this.dueToToDay = res.data||{};
      }).catch((err) => {console.log(err);});;
    },
    getExpirNexWeek() {
      const params = {
        exBgdt: this.utils.dateFormat(new Date(), "yyyy-MM-dd"),
        exExdt: this.utils.dateFormat(new Date(), "yyyy-MM-dd", null, 7),
      };
      expirApi(params).then((res) => {
        this.dueToNexWeek = res.data||{};
      }).catch((err) => {console.log(err);});;
    },
    getExpirNextMonth() {
      const params = {
        exBgdt: this.utils.dateFormat(new Date(), "yyyy-MM-dd"),
        exExdt: this.utils.dateFormat(new Date(), "yyyy-MM-dd", 1),
      };
      expirApi(params).then((res) => {
        this.dueToNextMonth = res.data||{};
      }).catch((err) => {console.log(err);});;
    },
    quotaChartDorw() {
      let myChart = this.$echarts.init(document.getElementById("quotaChart"));
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
          position: ["90%", "0%"],
          textStyle: {
            fontSize: "12",
          },
        },
        series: [
          {
            name: this.userObj && this.userObj["cstNm"],
            type: "pie",
            radius: ["74%", "92%"],
            avoidLabelOverlap: false,
            hoverOffset: 4,
            label: {
              normal: {
                show: true,
                position: "center",
                formatter:function(){
                  return "额度"
                },
                textStyle:{
                  color:"#555"
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "12",
                  fontFamily: "PingFangSC-Regular",
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: this.userObj && this.userObj["sumUsedAmt"],
                name: "已用额度",
              },
              {
                value: this.userObj && this.userObj["maxAmt"],
                name: "最高可用额度",
              },
            ],
          },
        ],
        color: ["#FF8686", "#669EFF"],
      });
    },
    getLines() {
      getLinesApi().then((res) => {
        const { lndList, goldAndRcvbList } = res.data;
        const { series } = this.todoDueChartOption;

        series[0].data = this.paddingData(
          lndList.map((item) => [item.date, item.amt, item.cnt])
        );

        series[1].data = this.paddingData(
          goldAndRcvbList.map((item) => [item.date, item.amt, item.cnt])
        );
        this.todoDueChartDorw();
      }).catch((err) => {console.log(err);});;
    },
    paddingData(data) {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const date = (_year, _month) =>
        `${_year}-${_month > 9 ? _month : "0" + _month}`;
      const padded = [];

      data.forEach((item) => {
        const dt = item[0] + "";
        const [_year, _month] = dt.split("-");
        const idx = (+_year - year) * 12 + (+_month - month);
        padded[idx] = item;
      });

      for (let i = 0; i < 12; i++) {
        if (this.utils.isUndefined(padded[i])) {
          const _year = month + i > 12 ? year + 1 : year;
          const _month = (month + i) % 12 || 12;
          padded[i] = [date(_year, _month), 0, 0];
        }
      }
      return padded;
    },
    todoDueChartDorw() {
        this.$nextTick(()=>{
            this.todoDueChart = this.$echarts.init(document.getElementById("todoDueChart"));
            this.todoDueChart.setOption(this.todoDueChartOption);
        })

    },
    tofunding(){
      this.MENUAPI.goToOneTab({
        path:"account/funding",
        params:{
          tabCur:"receiptCol"
        }
      })
    },
    togoldpay(){
      this.MENUAPI.goToOneTab({
        path:"circulation/goldpay"
      })
    },
    toborrow(){
      this.MENUAPI.goToOneTab({
        path:"circulation/borrow"
      })
    },
    toissue(){
      this.MENUAPI.goToOneTab({
        path:"bill-issue/issue"
      })
    },
    topayment(){
      this.MENUAPI.goToOneTab({
        path:"bill-payment/payment"
      })
    },
    tolegaltexts(){
      this.MENUAPI.goToOneTab({
        path:"inquiry/legaltexts"
      })
    },
    topayfee(){
      this.MENUAPI.goToOneTab({
        path:"account/payfee"
      })
    },
    // 打开资金明细-资金明细、回单明细页面
    toAccountFunding(tab){
      this.MENUAPI.goToOneTab({
        path:"account/funding",
        params:{
          tabCur:tab
        }
      })
    },
    recharge(){
      this.modalShow = true;
    },
    withdrawal(){
      this.MENUAPI.goToOneTab({
        path:"withdraw",

      })
    }
  },
  watch: {
    userObj: {
      handler(newName, oldName) {
        this.quotaChartDorw();
      },
      deep: true,
    },
  },
  activated() {},
};
</script>
<style scoped>
  .page-title {
    font-size: 16px;
    color: #0d253e;
    line-height: 40px;
    border-bottom:1px solid#D8D8D8;
    margin-bottom:24px;
    padding-bottom:8px;
  }
  .title-divider{
    background:#EE2223;
    margin-left: 0;
    width: 3px;
  }
  .card-item {
    width: 48%;
    max-width: 480px;
    margin-bottom: 20px;
  }
  .content-title {
    font-size: 16px;
    margin-bottom: 15px;
  }
  .content-line {
    color: #667380;
    margin: 10px 0;
  }
  .content-span {
    font-size: 12px;
    margin: 0 15px;
  }

  .main-btn-big {
    width: 86px;
  }
  .main-icon {
    margin-bottom: 15px;
    width: 50px;
    height: 50px;
  }
  .text-item {
    margin-right: 40px;
    line-height: 24px;
    width: 20%;
    max-width: 300px;
    margin-bottom:24px;
  }
  .text-margin {
    margin-right: 10px;
  }
  .main-link{
    margin:0 5px;
    text-decoration: underline;
  }
  .main-item-img{
    background: #FFF0D7;
    width: 72px;
    height: 72px;
    border-radius: 100%;
  }
  .main-item-icon{
    font-size:44px;
  }
  .main-item-text{
    text-align: center;
    font-weight: bold;
    margin-top:5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/main.vue